<template lang="pug">
  div
    v-row
      v-col(sm="6")
        TextBox(
          :error-messages="errors.name",
          :label="$t('form.redeemable.name')",
          :value.sync="model.name"
          @update:value="clearError('name')",
        )
      v-col(sm="6")
        NumberBox(
          :error-messages="errors.points",
          :label="$t('form.redeemable.points')",
          :value.sync="model.points"
          @update:value="clearError('points')",
        )
      v-col(sm="6")
        Datepicker(
          :error-messages="errors.start",
          :label="$t('form.redeemable.start')",
          :value.sync="start",
          @update:value="clearError('start')",
        )

      v-col(sm="6")
        Datepicker(
          :error-messages="errors.end",
          :label="$t('form.redeemable.end')",
          :value.sync="end",
          @update:value="clearError('end')",
        )

      v-col(sm="12")
        ShopPicker(
          :value.sync="shops",
          :error-messages="errors['0']",
          @update:value="clearError('0')",
        )

    TextBox(
      :error-messages="errors.description",
      :label="$t('form.redeemable.description')",
      :value.sync="model.description"
      @update:value="clearError('description')",
    )

    Uploader(
      editable,
      :error-messages="errors.media",
      :is-upload="isUpload",
      :is-video-src="false",
      :s3-location="model.s3_location",
      :value.sync="media",
      @update:value="clearError('media')",
      @update:error="displayError($event)",
      @update:isUpload="isUpload = true",
    )

    v-row(no-gutters)
      .flex-grow-1
      v-btn.mt-4(
        color="primary",
        :disabled="hasError || !valid",
        :loading="isLoading",
        :ripple="false",
        @click="submit",
      ) {{ $t(`form.redeemable.${ isEdit ? 'update': 'create'}`) }}
</template>

<script>
import { formHelper } from '@/config/mixins';
import { formatDate, tzUTC } from '@/utils/helper';
import Datepicker from '@/components/forms/inputs/Datepicker.vue';
import ShopPicker from '@/components/forms/inputs/ShopPicker.vue';
import Uploader from '@/components/forms/inputs/Uploader.vue';

export default {
  components: {
    Datepicker,
    ShopPicker,
    Uploader,
  },

  mixins: [formHelper],

  data: () => ({
    media: null,
    start: null,
    end: null,
    shops: [],
    isUpload: false,
  }),

  created() {
    if (this.isEdit && this.model.end.length === 24) {
      this.start = formatDate(this.model.start, 'dd/MM/yyyy');
      this.end = formatDate(this.model.end, 'dd/MM/yyyy');
    } else {
      this.start = this.model.start;
      this.end = this.model.end;
    }
    this.shops = this.model.shops;
    this.isUpload = !this.isEdit;
  },

  methods: {
    submit() {
      if (this.validate()) {
        const action = this.isEdit ? 'update' : 'create';
        const formData = new FormData();
        if (this.media) {
          formData.append('media', this.media);
        }
        formData.set('shops', this.shops);
        formData.set('name', this.model.name);
        formData.set('description', this.model.description);
        formData.set('points', this.model.points);
        formData.set('start', tzUTC(this.start, '00:00:01'));
        formData.set('end', tzUTC(this.end, '23:59:59'));

        const id = this.model.id || null;

        this.wrapProgress(() =>
          this.$store
            .dispatch(
              `redeemable/${action}`,
              {
                id,
                data: formData,
              },
              { root: true },
            )
            .then(() => this.$router.push({ name: 'redeemables' }))
            .catch(this.setError),
        );
      }
    },
  },
};
</script>
